import React, { useCallback } from "react";
import { useField } from "formik";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import Input from "../Input";

const initialDescr = {
  description: "",
  origin_qty: "",
  dest_qty: "",
  dest_room: "",
};

const fieldName = "notes.descriptions";

const NotesField = ({ isDonation, disabled }) => {
  const [field, , helpers] = useField({ name: fieldName });
  const fields = field.value || [];

  const handleAddNew = useCallback(() => {
    helpers.setValue(fields.concat(initialDescr));
  }, [helpers, fields]);

  const handleRemove = useCallback(
    i => helpers.setValue(fields.filter((v, index) => i !== index)),
    [helpers, fields]
  );

  return (
    <>
      {fields.map((v, index) => (
        <Grid key={index} size={12}>
          <Grid container spacing={1}>
            <Grid size={{ xs: isDonation ? 8 : 3, md: isDonation ? 10 : 6 }}>
              <Input
                disabled={disabled}
                name={`${fieldName}.${index}.description`}
                label="Description"
              />
            </Grid>
            <Grid size={{ xs: isDonation ? 4 : 9, md: isDonation ? 2 : 6 }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Grid container spacing={1}>
                  <Grid size={isDonation ? 12 : 4}>
                    <Input
                      disabled={disabled}
                      name={`${fieldName}.${index}.origin_qty`}
                      label="qty"
                    />
                  </Grid>
                  {!isDonation && (
                    <>
                      <Grid size={4}>
                        <Input
                          disabled={disabled}
                          name={`${fieldName}.${index}.dest_qty`}
                          label="Dest qty"
                        />
                      </Grid>
                      <Grid size={4}>
                        <Input
                          disabled={disabled}
                          name={`${fieldName}.${index}.dest_room`}
                          label="Dest Rm."
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
                {fields.length > 1 && (
                  <IconButton
                    sx={{ p: 1, mr: -1 }}
                    disabled={disabled}
                    aria-label="delete"
                    onClick={() => handleRemove(index)}
                  >
                    <DeleteIcon color="action" />
                  </IconButton>
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      ))}

      <Box mb={1} />

      <Grid size={12}>
        <Button
          id={`addNew-${fieldName.split(".").join("-")}`}
          variant="outlined"
          onClick={handleAddNew}
        >
          Add New <AddIcon color="action" fontSize="small" />
        </Button>
      </Grid>
    </>
  );
};

export default React.memo(NotesField);
